export function Sparkle() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C8.16552 1.99995 8.32641 2.05465 8.45759 2.15558C8.58877 2.25652 8.68288 2.39802 8.72526 2.55802L9.60951 5.90016L12.125 7.35072C12.239 7.41655 12.3337 7.51124 12.3995 7.62525C12.4653 7.73927 12.5 7.8686 12.5 8.00025C12.5 8.1319 12.4653 8.26123 12.3995 8.37525C12.3337 8.48926 12.239 8.58395 12.125 8.64978L9.60951 10.1011L8.72451 13.4425C8.68206 13.6023 8.58796 13.7437 8.45686 13.8445C8.32576 13.9453 8.16501 14 7.99963 14C7.83424 14 7.67349 13.9453 7.54239 13.8445C7.41129 13.7437 7.31719 13.6023 7.27475 13.4425L6.39049 10.1003L3.87497 8.64978C3.76096 8.58395 3.66629 8.48926 3.60047 8.37525C3.53465 8.26123 3.5 8.1319 3.5 8.00025C3.5 7.8686 3.53465 7.73927 3.60047 7.62525C3.66629 7.51124 3.76096 7.41655 3.87497 7.35072L6.39049 5.89941L7.2755 2.55802C7.31784 2.39814 7.41183 2.25673 7.54286 2.15581C7.6739 2.05489 7.83461 2.00011 8 2Z"
        fill="#2B3674"
      />
    </svg>
  );
}
